<template>
    <span class="ellipsis">
        {{ value }}
    </span>
</template>
<script>
import { dateFormat } from '../../plugins/filters'

export default {
  name: 'grid-cell-date',
  props: {
    value: {
      required: true
    },
    format: {
      required: false,
      default: false
    }
  },
  filters: {
    format (val) {
      if (this.format) {
        return dateFormat(val, this.format)
      }
      return val
    }
  }
}
</script>
